<template>
  <div>
    <h1>Forms</h1>
    {{ formData }}
    <esms-form v-model="formData" :spec="formSpec" />
  </div>
</template>

<script>
import EsmsForm from '../components/EsmsForm'

export default {
    components: {
        EsmsForm
    },
  data() {
    return {
      formData: {},
      formSpec: {
        sections: [
          {
            title: "Your Info",
            fields: [
              {
                id: "first_name",
                type: "string",
                name: "First Name",
                // description: "your first name",
                attrs: {
                  type: "input",
                  placeholder: "First name",
                  label: 'First Name',
                  required: false,
                  default: null
                }
              },
              {
                id: "last_name",
                type: "string",
                name: "Last Name",
                // description: "your first name",
                attrs: {
                  type: "input",
                  placeholder: "Last name",
                  label: 'Last Name',
                  required: false,
                  default: null
                }
              }
            ]
          }
        ]
      }
    };
  }
};
</script>